import { data } from 'jquery';

import * as Constants from '../constants/journey';

export const setActiveJourney = (journeyRecord) => ({
  type: Constants.SET_ACTIVE_JOURNEY,
  payload: journeyRecord,
});
